import { ReactNode } from 'react';
import { formatPhone } from '@cian/frontend-e2e-deal-component';
import { useDispatch, useSelector } from 'react-redux';

import { TFormSubmitStatus, TFormValues } from '../types';
import { CallConsultationRequest, ChoosingTypeConsultation, EmailConsultationRequest } from '../components';
import { useApplicationContext } from '../../../utils/applicationContext';
import { selectActiveStep } from '../../../selectors/consultationRequest';
import { setActiveStep } from '../../../actions/consultationRequest';
import { EActiveConsultationModal } from '../../../types/redux/states';

interface IUseActiveModalComponent {
  values: TFormValues;
  handleChangeInputValue: <T extends keyof TFormValues>(inputName: T, value: TFormValues[T]) => void;
  submitStatus: TFormSubmitStatus;
}

export const useActiveModalComponent = ({
  handleChangeInputValue,
  values,
  submitStatus,
}: IUseActiveModalComponent): ReactNode => {
  const { config } = useApplicationContext();
  const dispatch = useDispatch();
  const customerSupportPhone = formatPhone({
    phone: config.get<string>('partner-rewards.customerSupportContactPhone') ?? /* istanbul ignore next */ '',
  });
  const tgUrl = config.get<string>('transaction.consultationRequestTelegram') ?? /* istanbul ignore next */ '';

  const activeModal = useSelector(selectActiveStep);

  const setActiveModal = (step: EActiveConsultationModal) => {
    dispatch(setActiveStep(step));
  };

  switch (activeModal) {
    case EActiveConsultationModal.EmailForm:
      return (
        <EmailConsultationRequest
          values={values}
          handleInputChange={handleChangeInputValue}
          errors={submitStatus.errors}
        />
      );
    case EActiveConsultationModal.PhoneForm:
      return (
        <CallConsultationRequest
          values={values}
          handleInputChange={handleChangeInputValue}
          errors={submitStatus.errors}
          customerSupportPhone={customerSupportPhone}
        />
      );
    default:
      return <ChoosingTypeConsultation setActiveModal={setActiveModal} tgUrl={tgUrl} />;
  }
};
